import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { applyPisteMessages } from './pistes'
import './index.css'
import VShowSlide from 'v-show-slide'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import AOS from 'aos'
import 'aos/dist/aos.css'

library.add(faChevronDown);
library.add(faChevronUp);
library.add(faChevronLeft);
library.add(faPaperPlane);

applyPisteMessages(i18n)
Vue.config.productionTip = false
Vue.use(VShowSlide)
Vue.component("FontAwesomeIcon", FontAwesomeIcon);

new Vue({
  router,
  i18n,
  mounted() {
    AOS.init({
      duration: 600,
      once: true
    })
  },
  render: h => h(App),
}).$mount('#app')
